import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | VOCABULARY_WORD] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | VOCABULARY_WORD] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | VOCABULARY_WORD] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | VOCABULARY_WORD] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | VOCABULARY_WORD] Add Entity',
  UpdateEntity = '[STORE | ENTITY | VOCABULARY_WORD] Update Entity',
  RemoveEntity = '[STORE | ENTITY | VOCABULARY_WORD] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | VOCABULARY_WORD] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | VOCABULARY_WORD] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | VOCABULARY_WORD] Clean Up Snapshots',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.VocabularyWordEntityModels.VocabularyWord> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.VocabularyWordEntityModels.VocabularyWord> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.VocabularyWordEntityModels.VocabularyWord> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>